// Environment: Development (apidev.ac-it.4cee-dev.net)

export const environment = {
  production: false,
  envName: 'dev',
  apiBaseUrl: 'https://aidev.4cee-dev.net/api',
  keycloak: {
    issuer: 'https://auth.4cee-dev.net/realms/ai',
    clientId: 'ac-it',
    scope: 'openid profile email offline_access',
    responseType: 'code',
    showDebugInformation: true,
    requireHttps: false,
    idpHint: 'microsoft'
  }
};
